import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * ⚠️ HAND-WRITTEN FILE - DO NOT DELETE! ⚠️
 *
 * Pixel-art Vic Viper spaceship icon — a callback to Gradius (1986),
 * the first game to feature the Konami Code.
 * Unlocked as an achievement badge after entering ↑↑↓↓←→←→BA.
 */
export function VicViperIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props} viewBox="0 0 24 24">
      {/* Pixel-art Vic Viper facing right — forward-swept wings, narrow fuselage */}
      <g>
        {/* Nose */}
        <rect x="20" y="11" width="2" height="2" />
        {/* Fuselage */}
        <rect x="10" y="11" width="10" height="2" />
        {/* Cockpit */}
        <rect x="16" y="10" width="4" height="1" />
        <rect x="16" y="13" width="4" height="1" />
        {/* Top wing — sweeps forward */}
        <rect x="6" y="5" width="2" height="1" />
        <rect x="8" y="6" width="2" height="1" />
        <rect x="10" y="7" width="2" height="1" />
        <rect x="10" y="8" width="4" height="1" />
        <rect x="10" y="9" width="6" height="1" />
        <rect x="10" y="10" width="6" height="1" />
        {/* Bottom wing — sweeps forward */}
        <rect x="10" y="13" width="6" height="1" />
        <rect x="10" y="14" width="6" height="1" />
        <rect x="10" y="15" width="4" height="1" />
        <rect x="10" y="16" width="2" height="1" />
        <rect x="8" y="17" width="2" height="1" />
        <rect x="6" y="18" width="2" height="1" />
        {/* Engine exhaust */}
        <rect x="8" y="11" width="2" height="2" />
        <rect x="5" y="11.5" width="3" height="1" opacity="0.5" />
        <rect x="2" y="11.5" width="3" height="1" opacity="0.25" />
      </g>
    </SvgIcon>
  );
}
